import { Location } from "@angular/common";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Observable, EMPTY } from "rxjs";
import { map, startWith, switchMap } from "rxjs/operators";
import { LoggingService } from "src/app/logging.service";
import { BreadcrumbService } from "src/app/shared/services/breadcrumb.service";
import { CommonService } from "src/app/shared/services/common.service";
import { FilterService } from "src/app/shared/services/filter.service";
import { IdeaPitchService } from "src/app/shared/services/ideapitch.service";
import { MessageService } from "src/app/shared/services/message.service";
import { ProgramService } from "src/app/shared/services/program.service";
import { TagsService } from "src/app/shared/services/tag.service";
import textConfiguration from "src/assets/static-text-configuration.json";

@Component({
  selector: "app-create-idea-pitch",
  templateUrl: "./create-idea-pitch.component.html",
  styleUrls: ["./create-idea-pitch.component.scss"],
})
export class CreateIdeaPitchComponent implements OnInit {
  @Input() ideaId: any;
  @Output() formSubmitted = new EventEmitter<any>();
  commonText: any = (textConfiguration as any).common;
  okr: any;
  panelOpenState = false;
  panelOpenState1 = false;
  isBaselined = false;
  ideaData: any;
  newForm: any;
  linkURL: any;
  serviceProviders: any = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  options2: any;
  filteredOptions2: any;
  options1: any;
  filteredOptions1: any;
  subPortOptions: any;
  ownersOptions: any;
  programOptions: any;
  programFilteredOptions: any;
  filterOptionType: Observable<any[]>;
  filterOptionPortfolio: Observable<any[]>;
  filterOptionSubPortfolio: Observable<any[]>;
  filterOptionOwners: Observable<any[]>;
  filterOptionProgram: Observable<any[]>;
  subPortfilteredOptions: any;
  subPortFolioChild: any;
  ownerDetails: any;
  displayLabels: any;
  dataLoaded = true;
  ideaTags: any;

  constructor(
    private readonly router: Router,
    private readonly location: Location,
    private readonly fb: FormBuilder,
    private readonly ideaPitchService: IdeaPitchService,
    private readonly spinner: NgxSpinnerService,
    private readonly toastrService: ToastrService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly messageService: MessageService,
    private readonly ps: ProgramService,
    private readonly commonService: CommonService,
    private readonly tagService: TagsService,
    private readonly filterService: FilterService,
    private readonly loggingService: LoggingService,
    private readonly breadCrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.getDisplayLables();

    // // Base breadcrumb (common for all cases)
    // const baseBreadcrumb = [
    //   { label: "CoSInE", url: "" },
    //   {
    //     label: "Idea Workbench",
    //     url: "/challenge-workbench/challenge-statements",
    //   },
    //   {
    //     label: "Idea Pitch",
    //     url: "/challenge-workbench/challenge-statements?tab=ideapitch",
    //   },
    // ];

    // // Set initial breadcrumb
    // this.breadCrumbService.setBreadcrumb(baseBreadcrumb);

    // Track page in message service
    this.messageService.setGnews({ pagename: "Idea Pitch creation" });

    // Detect if edit mode (with ID) or new
    this.activatedRoute.params.subscribe((params) => {
      if (params.id) {
        this.ideaId = atob(params.id);
        this.getIdeaById(); // will update breadcrumb with title later
      }
    });

    // Initialize form
    this.newForm = this.fb.group({
      id: [""],
      title: ["", Validators.required],
      description: ["", Validators.required],
      links: this.fb.array([]),
      status: [""],
      files: this.fb.array([]),
      tag_ids: [],
      vendor_id: ["", Validators.required],
      impact: ["", Validators.required],
      technologies: ["", Validators.required],
      poc_expectations: ["", Validators.required],
      portfolio: ["", Validators.required],
      subPortfolio: ["", Validators.required],
      program: ["", Validators.required],
      owners: ["", Validators.required],
      owner_id: [""],
    });

    this.getAllServiceProviderList();
    this.getList();
  }

  getDisplayLables() {
    this.displayLabels = this.commonService.getLabels();
  }

  getAllServiceProviderList() {
    this.ideaPitchService
      .getAllServiceProviderList()
      .subscribe(async (res: any) => {
        if (res) {
          res.forEach((element: any) => {
            if (!element.url) {
              element.url = "";
            }
          });
          this.serviceProviders = res;
        }
      });
  }

  getIdeaById() {
    this.dataLoaded = false;
    this.ideaPitchService.getIdeaPitch(this.ideaId).subscribe(
      (res: any) => {
        this.dataLoaded = true;
        this.spinner.hide();
        this.ideaData = res;
        const breadcrumb = [
          { label: "CoSInE", url: "" },
          {
            label: "Opportunity Workbench",
            url: "/program",
          },
          {
            label: "Partner Ideas",
            url: "/program",
            queryParams: { tab: 1 },
          },
          {
            label: res.title,
            url: "",
          },
        ];
        this.breadCrumbService.setBreadcrumb(breadcrumb);
        this.messageService.setGnews({
          pagename: "Idea Pitch edit",
          queryParam: { idea_title: res.title },
        });

        this.newForm.patchValue(res);
        this.newForm.patchValue({
          portfolio: res?.portfolio?.parent_portfolio,
          subPortfolio: res?.portfolio,
          owners:
            res?.portfolio?.owner_details.full_name ||
            res?.portfolio?.owner_details.username,
          owner_id: res?.portfolio?.owner_details.id,
        });

        res?.links.forEach((link: any) => {
          this.linksControls.push(this.createLinksControl(link));
        });

        if (res?.vendor) {
          this.newForm.get("vendor_id").setValue(res.vendor.id);
        }
        if (res?.status === "in accelerator") {
          this.isBaselined = true;
          this.newForm.disable();
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.dataLoaded = true;
        this.toastrService.error("Error while fetching the idea");
        throw error;
      }
    );
  }

  goToUnderCommercials() {
    this.formSubmitted.emit("next");
  }

  get linksControls() {
    return this.newForm.get("links") as FormArray;
  }

  createLinksControl(link: any): FormControl {
    return this.fb.control(link);
  }

  async getList() {
    this.filterService
      .getPortfolioList()
      .toPromise()
      .then((resp: any) => {
        this.options1 = resp.records;
        this.filteredOptions1 = this.options1;
        this.initAutoComplete();
      })
      .catch((error) => {
        this.loggingService.error("Error fetching portfolios: ", error);
      });
  }

  initAutoComplete(): any {
    const portfolioControl = this.newForm.get("portfolio");
    if (portfolioControl) {
      this.filterOptionPortfolio = portfolioControl.valueChanges.pipe(
        startWith(""),
        map((value: any) => {
          if (typeof value === "string") {
            return value;
          } else {
            return value?.name;
          }
        }),
        map((name: any) => {
          if (name) {
            return this.portfolioFilter(name);
          } else {
            return this.filteredOptions1.slice();
          }
        })
      );
    }
  }

  private portfolioFilter(value: string): any {
    const filterValue = value.toLowerCase();
    return this.filteredOptions1?.filter((i: any) =>
      i.name.toLowerCase().includes(filterValue)
    );
  }
  private subPortfolioFilter(value: string): any {
    const filterValue = value.toLowerCase();
    return this.subPortfilteredOptions?.filter((i: any) =>
      i.name.toLowerCase().includes(filterValue)
    );
  }
  private programFilter(value: string): any {
    const filterValue = value.toLowerCase();
    return this.programFilteredOptions?.filter((i: any) =>
      i.name.toLowerCase().includes(filterValue)
    );
  }

  onSelectionChangePortfolio(event: any) {
    const portFolioId = event.source.value.id;
    this.subPortfilteredOptions = [];
    if (!portFolioId) {
      return;
    }
    this.newForm.patchValue({
      subPortfolio: "",
      owners: "",
      owner_id: "",
    });

    this.filterService
      .getSubportfolioList(portFolioId)
      .subscribe((resp: any) => {
        this.subPortOptions = resp.records;
        this.subPortfilteredOptions = this.subPortOptions;
        const subportfolioControl = this.newForm.get("subPortfolio");
        if (subportfolioControl) {
          this.filterOptionSubPortfolio = subportfolioControl.valueChanges.pipe(
            startWith(""),
            map((value: any) => {
              if (typeof value === "string") {
                return value;
              } else {
                return value?.name;
              }
            }),
            map((name: any) => {
              if (name) {
                return this.subPortfolioFilter(name);
              } else {
                return this.subPortfilteredOptions.slice();
              }
            })
          );
        }
      });
  }

  onSelectionChangeSubportPortfolio(e: any) {
    const subportFolioId = e.source.value.id;
    this.programOptions = [];
    if (!subportFolioId) {
      return;
    }
    this.newForm.patchValue({
      program: "",
    });
    let value = e.source.value;

    this.filterService
      .getProgram(e.source.value.id)
      .subscribe(async (resp: any) => {
        this.programOptions = resp.records;
        const programControl = this.newForm.get("program");
        if (programControl) {
          this.filterOptionProgram = programControl.valueChanges.pipe(
            startWith(""),
            map((value: any) => {
              if (typeof value === "string") {
                return value;
              } else {
                return value?.name;
              }
            }),
            map((name: any) => {
              if (name) {
                return this.programFilter(name);
              } else {
                return this.programOptions.slice();
              }
            })
          );
        }
      });
    this.subPortFolioChild = [];
    this.ownerDetails = value.owner;
    this.newForm.patchValue({
      owners: value.owner?.first_name + value.owner?.last_name,
      owner_id: value.owner?.id,
    });
  }

  async addTags(id: any) {
    if (this.ideaTags?.length > 0) {
      await this.ideaTags.forEach(async (element: any) => {
        const pst = {
          entity_id: id,
          entity_type: "ideapitch",
          tag_id: element.id,
        };
        this.tagService.magTag(pst).subscribe(() => {});
      });
    }
  }

  submitData(type: any) {
    this.newForm.get("status").setValue(type);
    if (this.newForm.invalid) {
      this.toastrService.error("Please fill the mandatory input");
      return;
    }
    this.spinner.show();
    const formData = new FormData();
    formData.append("title", this.newForm.value.title);
    formData.append("description", this.newForm.value.description);
    formData.append("status", type);
    if (this.newForm.value.links.length === 0) {
      formData.append("links", "");
    }
    for (let link of this.newForm.value.links) {
      formData.append("links", link);
    }
    formData.append("vendor_id", this.newForm.value.vendor_id);
    this.newForm.get("files").value.forEach((file: any) => {
      formData.append("files", file);
    });
    formData.append("impact", this.newForm.value.impact);
    formData.append("technologies", this.newForm.value.technologies);
    formData.append("poc_expectations", this.newForm.value.poc_expectations);
    formData.append("portfolio_id", this.newForm.value.subPortfolio.id);
    formData.append("program_id", this.newForm.value.program.id);
    formData.append("owner_id", this.newForm.value.owner_id);
    this.handleIdeaSubmission(formData, type);
  }

  /**
   * ✅ Handles the complete idea submission flow
   * - Updates the idea
   * - If not draft, moves to accelerator
   * - Emits event only after both calls succeed
   */
  private handleIdeaSubmission(formData: FormData, type: string) {
    this.ideaPitchService
      .updateIdeaPitch(this.ideaData?.id, formData)
      .pipe(
        switchMap((updateRes: any) => {
          if (type === "draft") {
            // Handle draft case
            this.spinner.hide();
            this.toastrService.success("Idea updated successfully");
            this.formSubmitted.emit({
              moveId: null,
              vendorInvestments: updateRes.vendor?.investments || [],
            });
            return EMPTY; // stop the chain
          } else {
            // Non-draft → also move to accelerator
            this.createResponse(updateRes.id);

            const payload = {
              source: this.ideaId,
              status: "under_commercials",
            };

            return this.ideaPitchService.moveToAccelerator(payload).pipe(
              map((accRes: any) => ({
                accId: accRes.id,
                vendor: updateRes.vendor || [],
              }))
            );
          }
        })
      )
      .subscribe({
        next: (finalResult) => {
          if (!finalResult) return; // handled draft case already
          this.spinner.hide();
          this.formSubmitted.emit(finalResult);
          this.isBaselined = true;
          this.newForm.disable();
          this.toastrService.success("Idea updated successfully");
        },
        error: (error) => {
          this.spinner.hide();
          this.toastrService.error("Error while submitting the idea");
          throw error;
        },
      });
  }

  moveToDeliveryAccelerator() {
    const payload = {
      source: this.ideaId,
      status: "under_commercials",
    };
    this.ideaPitchService.moveToAccelerator(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.formSubmitted.emit(res.id);
        this.isBaselined = true;
        this.newForm.disable();
      },
      (error: any) => {
        this.spinner.hide();
        this.toastrService.error("Error while submitting the idea");
        throw error;
      }
    );
  }

  rejectIdea() {
    const payload = {
      status: "rejected",
    };
    this.ideaPitchService
      .updateIdeaPitch(this.ideaData?.id, payload)
      .subscribe(async (res: any) => {
        if (res) {
          this.toastrService.success("Idea rejected successfully");
          this.navigateBack();
        }
      });
  }

  createResponse(ideaId: any) {
    const payload = {
      idea_pitch_id: ideaId,
      status: "draft",
    };
    this.ideaPitchService.createResponse(payload).subscribe(
      () => {},
      (error: any) => {
        this.spinner.hide();
        this.toastrService.error("Error while adding tenant response");
        throw error;
      }
    );
  }

  updateIdea(formData: any, type: any) {
    this.ideaPitchService
      .updateIdeaPitch(this.ideaData?.id, formData)
      .subscribe(async (res: any) => {
        if (res) {
          this.spinner.hide();
          if (type === "draft") {
            this.toastrService.success("Idea updated successfully");
          } else {
            this.createResponse(res.id);
          }
        }
      });
  }

  deleteFile(fileId: any) {
    this.spinner.show();
    this.ideaPitchService.deleteIdeaPitchFile(fileId).subscribe(() => {
      this.spinner.hide();
      this.ideaData.idea_pitch_files = this.ideaData?.idea_pitch_files?.filter(
        (item: any) => item.id !== fileId
      );
      this.toastrService.success("File deleted successfully");
    });
  }

  onFileSelected(event: any) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0];
      this.commonService.validateFileSize(file).subscribe((isValid) => {
        if (!isValid) {
          this.toastrService.error("Please upload less than 50MB");
          return;
        }
        this.addFile(file);
      });
    }
  }

  addFile(file: any) {
    this.fileControls.push(this.createFileControl(file));
  }

  createFileControl(file: any): FormControl {
    return this.fb.control(file);
  }

  get fileControls() {
    return this.newForm.get("files") as FormArray;
  }

  displayFnName(data: any) {
    if (data?.name) {
      return data.name;
    } else {
      return data?.full_name;
    }
  }

  removeFile(index: number) {
    this.fileControls.removeAt(index);
  }

  getType(x: any) {
    const ext = x.substring(x.lastIndexOf(".") + 1);
    return ext?.toLowerCase();
  }

  addLink() {
    if (this.linkURL && this.linkURL.trim() !== "") {
      this.linksControls.push(this.fb.control(this.linkURL.trim()));
      this.linkURL = "";
    }
  }

  getGMapRandomColor() {
    const colorNum = 360;
    const color = Math.floor(Math.random() * colorNum);
    return `hsla(${color}, 100%, 40%, 80%)`;
  }

  navigateTo(url: any) {
    this.router.navigateByUrl(url);
  }

  getTagObject() {
    return {
      entity_id: this.ideaId,
      entity_type: "ideapitch",
    };
  }

  goBack() {
    this.location.back();
  }

  openLink(x: any) {
    window.open(x, "_blank");
  }

  removeLink(index: number) {
    this.linksControls.removeAt(index);
  }

  navigateBack() {
    this.router.navigateByUrl(
      "/challenge-workbench/challenge-statements?tab=ideapitch"
    );
  }

  getChildTags(data: any) {
    this.ideaTags = data;
  }
}
